// Icona WhatsApp cliccabile accanto ai campi cellulare.
// Visibile solo se il numero è valorizzato; apre https://wa.me/<numero> (con firma studio) in nuova scheda.
import { openWhatsApp } from "../lib/waLink";
export function toWaNumber(raw) {
  let d = (raw || "").replace(/[^\d]/g, "");
  if (!d) return "";
  if (d.startsWith("00")) d = d.slice(2);
  if (!d.startsWith("39") && (d.startsWith("3") || d.startsWith("0"))) {
    if (d.startsWith("0")) d = d.replace(/^0+/, "");
    d = "39" + d;
  }
  return d;
}

// Elenco numeri (principale + extra) con etichetta, senza duplicati: [{ n, label }].
export function cellOptions(rec, mainKey = "cellulare") {
  if (!rec) return [];
  const labels = Array.isArray(rec.cellulari_etichette) ? rec.cellulari_etichette : [];
  const out = [];
  [rec[mainKey], ...(Array.isArray(rec.cellulari_extra) ? rec.cellulari_extra : [])].forEach((n, i) => {
    const v = (n || "").trim();
    const w = toWaNumber(v);
    if (w && !out.some((o) => toWaNumber(o.n) === w)) out.push({ n: v, label: String(labels[i] || "").trim() });
  });
  return out;
}

export const WaGlyph = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.516 5.26l-.999 3.648 3.472-.907zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
  </svg>
);


export default function WhatsAppLink({ number, className = "", size = "h-4 w-4", testId, text, onOpen }) {
  const wa = toWaNumber(number);
  if (!wa) return null;
  const go = (n) => { if (onOpen) { onOpen(n); return; } openWhatsApp(toWaNumber(n), text || ""); };
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); go(number); }}
      title={`Scrivi su WhatsApp (+${wa})`}
      aria-label="Apri WhatsApp"
      data-testid={testId}
      className={`inline-flex items-center justify-center shrink-0 text-[#25D366] hover:text-[#1ebe5d] hover:scale-110 transition-transform ${className}`}
    >
      <WaGlyph className={size} />
    </button>
  );
}
